module.exports = __webpack_public_path__ + "img/quizmayhem_banner_egypt.4e17d543.jpg";